import { DEFAULT_LAYOUT } from '../base';
import { AppRouteRecordRaw } from '../types';

const REPORT: AppRouteRecordRaw = {
  path: '/report',
  name: 'report',
  component: DEFAULT_LAYOUT,
  redirect: '/report/report',
  meta: {
    locale: 'menu.report',
    requiresAuth: true,
    icon: 'icon-file',
    order: 4,
    hideChildrenInMenu: true,
    activeMenu: 'report',
  },
  children: [
    {
      path: 'report',
      name: 'Report',
      component: () => import('@/views/report/index.vue'),
      meta: {
        locale: 'menu.report.report',
        requiresAuth: true,
        roles: ['*'],
      },
    },
  ],
};

export default REPORT;
